// A section of a long dialog that starts collapsed to one line — its title and a
// summary of what's set up — and opens to edit. Used by the Event dialog, whose
// managers each report their own summary.
//
// The body stays mounted while collapsed (just hidden), because the managers
// inside load their data themselves and it's that data the summary is built from.
import { useState } from "react";
import { Box, ButtonBase, Collapse, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

/** Props: title, summary (text shown beside the title), defaultOpen, children. */
export default function CollapsibleSection({ title, summary, defaultOpen = false, children }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <Box sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1 }}>
      <ButtonBase onClick={() => setOpen(o => !o)} aria-expanded={open}
                  sx={{ width: "100%", justifyContent: "flex-start", textAlign: "left",
                        px: 1.5, py: 1, gap: 1, borderRadius: 1 }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="subtitle2">{title}</Typography>
          {summary && (
            <Typography variant="caption" color="text.secondary" component="div"
                        sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {summary}
            </Typography>
          )}
        </Box>
        <ExpandMoreIcon sx={{ transition: "transform 150ms", transform: open ? "rotate(180deg)" : "none",
                              color: "action.active" }} />
      </ButtonBase>
      <Collapse in={open}>
        <Box sx={{ px: 1.5, pb: 1.5 }}>{children}</Box>
      </Collapse>
    </Box>
  );
}
